import {helpers} from '@teamrazr/redux'

const mediaResize = helpers.createAction('MEDIA_RESIZE', 'breakpoint')

export const setMediaBreakpoint = (breakpoint) => (dispatch) =>
  dispatch(mediaResize(breakpoint))
